import type { ConsoleScreenMap } from '../types'
import { lazyScreen } from '../lazyScreen'
const TeacherHomeScreen = lazyScreen(() => import('./home/HomeScreen'), (m) => m.TeacherHomeScreen)
const PlayScreen = lazyScreen(() => import('./play/PlayScreen'), (m) => m.PlayScreen)
const ClassScreen = lazyScreen(() => import('./class/ClassScreen'), (m) => m.ClassScreen)
const ChildrenScreen = lazyScreen(() => import('./children/ChildrenScreen'), (m) => m.ChildrenScreen)
const AttendanceScreen = lazyScreen(() => import('./attendance/AttendanceScreen'), (m) => m.AttendanceScreen)
const ReportsScreen = lazyScreen(() => import('./reports/ReportsScreen'), (m) => m.ReportsScreen)
const MessagesScreen = lazyScreen(() => import('./messages/MessagesScreen'), (m) => m.MessagesScreen)
const HelpScreen = lazyScreen(() => import('./help/HelpScreen'), (m) => m.HelpScreen)

/**
 * The teacher tier's redesigned screens, by route. A route listed here is served
 * by the console registry ahead of AppRouter's older switch; a route not
 * listed keeps its existing screen. Owned by the teacher workstream.
 *
 * The old self-chromed `TeacherApp` stays in `features/dashboards/teacher` —
 * its models (`classChoice`, `teacherFlow`, `playLaunch`, the attendance and
 * roster folds) are reused here; its UI is not.
 */
export const TEACHER_SCREENS: ConsoleScreenMap = {
  teacher: { component: TeacherHomeScreen },
  'teacher-play': { component: PlayScreen },
  'teacher-class': { component: ClassScreen },
  'teacher-children': { component: ChildrenScreen },
  'teacher-attendance': { component: AttendanceScreen },
  'teacher-reports': { component: ReportsScreen },
  'teacher-messages': { component: MessagesScreen },
  'teacher-help': { component: HelpScreen },
}
